import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { Field } from "@/pages/auth/Login";
import { api, fmtErr } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { toast } from "sonner";

export default function Reset() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please log in.");
      nav("/login");
    } catch (e2) { setErr(fmtErr(e2.response?.data?.detail)); }
  };

  return (
    <AuthShell title="Reset password" subtitle="Choose a new password for your account."
      footer={<Link to="/login" className="font-semibold text-primary">Back to login</Link>}>
      <Seo title="Reset password" />
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <Field label="New password" type="password" value={password} onChange={setPassword} testid="reset-password" />
        {err && <p className="text-sm text-bearish" data-testid="reset-error">{err}</p>}
        <button data-testid="reset-submit" className="w-full rounded-xl bg-primary py-2.5 text-sm font-semibold text-primary-foreground">Reset password</button>
      </form>
    </AuthShell>
  );
}
